import { localeAliases, supportedLocales } from 'configs/i18n/config'

const getMatchedLocale = (value?: string): string | undefined => {
  if (!value) return undefined
  const lowerValue = value.toLowerCase()
  return supportedLocales.find(locale => locale.toLowerCase() === lowerValue)
}

const resolveAlias = (value: string): string | undefined => {
  const aliasTarget = localeAliases[value as keyof typeof localeAliases]
  if (!aliasTarget) return undefined
  return getMatchedLocale(aliasTarget)
}

export const normalizeLocale = (candidate?: string): string | undefined => {
  if (!candidate) return undefined

  const lowerCandidate = candidate.toLowerCase()
  const directMatch = getMatchedLocale(lowerCandidate)
  if (directMatch) return directMatch

  const aliasMatch = resolveAlias(lowerCandidate)
  if (aliasMatch) return aliasMatch

  const [baseLocale] = lowerCandidate.split(/[_-]/)
  if (baseLocale && baseLocale !== lowerCandidate) {
    const baseDirectMatch = getMatchedLocale(baseLocale)
    if (baseDirectMatch) return baseDirectMatch

    const baseAliasMatch = resolveAlias(baseLocale)
    if (baseAliasMatch) return baseAliasMatch
  }

  return undefined
}
